import React, { PropsWithChildren } from 'react';
import { makeStyles, Tooltip } from '@material-ui/core';

interface Props {
    label?: string;
    required?: boolean;
    disabledReason?: string;
    labelWidth?: string;
}

export const FormField = ({
    children,
    label,
    required = false,
    disabledReason = "",
    labelWidth,
}: PropsWithChildren<Props>) => {
    const classes = useStyles(Boolean(disabledReason), labelWidth)();

    if (!label) {
        return <>{children}</>
    }

    return (
        <Tooltip
            title={disabledReason}
            placement="bottom-start"
        >
            <div className={classes.formField}>
                <label className={classes.label}>
                    {`${label}:${required ? " *" : ""}`}
                </label>
                {children}
            </div>
        </Tooltip>
    );
};

const useStyles = (disabled: boolean, labelWidth?: string) => makeStyles((theme) => ({
    formField: {
        display: "flex",
        alignItems: "center",
        margin: "5px 0"
    },
    label: {
        color: disabled ? theme.palette.grey[400] : undefined,
        marginRight: "5px",
        ...(labelWidth ? { width: labelWidth, flexShrink: 0 } : {}),
    },
}));
